import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ServerApi } from '../../services/server-api';
import { Session } from '../../services/session';

interface IServerPersonaSurveyRequest {
  id: number;
  company_role?: string;
  industry?: string;
  freight_carried?: string[];
  attempts?: number;
}

interface IServerResponseStatus {
  status: string;
  code: number;
}

const URL = 'surveys/user_persona';

export const userRoles: string[] = [
  $localize`Compliance Manager`,
  $localize`Dispatcher`,
  $localize`IT Manager`,
  $localize`Mechanic`,
  $localize`Operations Manager`,
  $localize`Owner`,
  $localize`Safety Manager`,
  $localize`Other`,
];

export const companyRoles: string[] = [
  $localize`Agriculture`,
  $localize`Construction & Materials`,
  $localize`Food & Beverage`,
  $localize`Household Goods`,
  $localize`Machinery`,
  $localize`Motor Vehicles`,
  $localize`Oil & Gas`,
  $localize`Other`,
];

export const industries: string[] = [
  $localize`Agriculture`,
  $localize`Construction`,
  $localize`Field Services`,
  $localize`Food & Beverage`,
  $localize`For-Hire Trucking`,
  $localize`Manufacturing`,
  $localize`Moving & Storage`,
  $localize`Oil & Gas`,
  $localize`Passenger Transport`,
  $localize`Other`,
];

@Injectable({
  providedIn: 'root',
})
export class PersonaSurveyModalService {
  public closedByUser: boolean = false;

  private payload: IServerPersonaSurveyRequest = {
    id: this.session.getUserId(),
  };

  constructor(
    private session: Session,
    private api: ServerApi,
  ) { }

  public updateUsersCompanyRole(role: string): Observable<IServerResponseStatus> {
    this.payload.company_role = role;
    return this.api.post(URL, this.payload);
  }

  public updateIndustry(industry: string): Observable<IServerResponseStatus> {
    this.payload.industry = industry;
    return this.api.post(URL, this.payload);
  }

  public updateFreightCarriers(freightCarriers: string[]): Observable<IServerResponseStatus> {
    this.payload.freight_carried = freightCarriers;
    return this.api.post(URL, this.payload);
  }

  public updateAttempts (): Observable<IServerResponseStatus> {
    this.payload.attempts = (this.session.getPersonaSurveyAttempts() || 0) + 1;
    return this.api.post(URL, this.payload);
  }
}
